// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yBWj","footer":"styles_footer__3UV4s","passCodeTooltip":"styles_passCodeTooltip__1PqOM"};